import styled from 'styled-components'

export const NavListInner = styled.ul`
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  padding-top: calc(100vw * (8 / 375));
  padding-bottom: calc(100vw * (28 / 375));
  background-color: #ffffff;
  border-top: solid calc(100vw * (1 / 375)) #d8d8d8;
`
export const NavIconInner = styled.span`
  position: relative;
  text-align: center;
  display: inline-block;
  min-width: calc(100vw * (70 / 375));
`
export const NavIcon = styled.span`
  display: block;
  width: calc(100vw * (24 / 375));
  height: calc(100vw * (24 / 375));
  margin: 0 auto;
`
